import React, { Component } from 'react';
import FormViewer from '../../components/FormViewer';
import Responsive from '../../components/Responsive';
import { translate } from '../../utils/useful';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import { countriesList } from '../../variables/countries';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class CHHubInfo extends Component {

    state = {
        formHeaders: [
            { key: 'image', type: 'ProfileImageInput', theme: 'transparent', information: { label: '{{lang}}image', placeholder: '{{lang}}image', placeHolderImage: '', inputClass: 'none', required: false, cropper: true, ratio: '1:1', single: true } },
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
            { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false } }
        ]
    }

    componentDidMount() {
        // console.log('pricingggggggg', this.props.user.info)

        let countries = countriesList
        let formHeaders = []
        let countriesItems = []
        let currenciesItems = []
        countries.forEach(country => {
            let countryItem = { title: country.name, value: country.code }
            let currencyItem = { title: `${country.currency} (${country.symbol})`, value: country.code }
            // let title = country.name
            // let value = country.code
            countriesItems.push(countryItem)
            currenciesItems.push(currencyItem)
        });
        // let countryHeader = { key: 'country', type: 'SelectInput', information: { type: 'local', items: countriesItems, placeholder: '{{lang}}Country', required: true } }
        // let currencyHeader = { key: 'currency', type: 'SelectInput', information: { type: 'local', items: currenciesItems, placeholder: '{{lang}}Currency', required: true },
        let header = [
            { key: 'country', type: 'SelectInput', information: { label: 'Country', type: 'local', items: countriesItems, placeholder: '{{lang}}Country', required: true } },
            {
                key: 'currency', type: 'SelectInput', information: { label: 'Currency', type: 'local', items: currenciesItems, placeholder: '{{lang}}Currency', required: true },
                dependencies: [{
                    refKey: 'country', targetKey: 'currency',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeValue: true }
                    }],
                    else: { show: true, changeHeader: [{}] },
                    init: true,
                    // show:true,

                }]
            }]
        formHeaders = header
        // }
        // let timezoneHeader = { key: 'timezone', type: 'MultiSelectInput', information: { type: 'local', address: '', filter: {}, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}Timezone', required: true } }
        // formHeaders.push(countryHeader)
        // formHeaders.push(currencyHeader)
        // formHeaders.push(timezoneHeader)
        this.setState({ formHeaders })
        if (this.setHeader) {
            // this.props.setHeader("dummy",1)
            this.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // 'title': `${this.props.user?.info?.fullname}`,
                'info': 'Create Hub | Hub Info',
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }

    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoading}
                    onClick={this.nextClicked}
                    title={translate("Next Step")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    nextStage = (cb) => {
        // this.setState({ isLoading: true, errors: {} })
        if (this.form) {
            let data = this.form.getForm()
            if (data) {
                // console.log('dataaaaaaaaaaaaaaaasdf', data)
                window.scrollTo(0, 0)

                this.props.setData(data, () => {
                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // this.setState({ isLoading: false })
                    this.props.nextStage()

                    // })
                })
            }
        }
    }


    formLiveChange = (data) => {

        if (data?.name && data?.name != '') {
            this.setState({ canContinue: true })
        } else {
            this.setState({ canContinue: false })
        }
    }


    nextClicked = () => {
        let form = this.form.getForm()
        // if (form && this.state.canContinue) {

        this.props.setData(form, () => {
            this.props.changeStage("pricing")
        })

        // }
    }



    render() {
        return (
            <div className=" w-100 h-100 position-relative window-content-radius" style={{ backgroundColor: '#f5f5f5' }}>
                <div className='w-100' style={{ position: 'sticky', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div>
                <div className='flexcc w-100 h-100'>
                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '8', md: '8', lg: "6", xl: "6" }}>
                        <div className='h-100 w-100 flexc flex-column scroll-no-scrollbar' style={{ padding: '0px 4%' }}>
                            <div className='w-100 ' style={{ paddingTop: '3%' }}>
                                <div style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}>
                                    <div className='px-1'>
                                        <div className='w-100 ' style={{ backgroundColor: '#fff', height: 16, borderRadius: '16px 16px 0px 0px', transform: 'translateY(1px)', marginTop: -1 }}></div>
                                    </div>
                                </div>
                                <div className='px-1 ' style={{ marginTop: -16 }}>
                                    <div className='px-2 pt-1' style={{ backgroundColor: '#fff', borderRadius: '16px 16px 16px 16px', position: 'relative', zIndex: 5 }}>
                                        <div className='d-flex flex-wrap mt-4'>
                                            <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} liveChange={this.formLiveChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CHHubInfo);